export default __webpack_public_path__ + "43d192a7c17f0ccd86af1f072ed25cf3.png";